var exports = {
  "I": "actionListItem__jlNlIw",
};

module.exports = exports;
